import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import ActionTypesEnum from "@shared/enums/action-constant.enum";
import { validateFormGroup } from "@shared/utils/form.util";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomEventService } from "@shared/services/custom-event.service";
import { PropertiesService } from "@core/services/properties.service";

@UntilDestroy()
@Component({
  selector: 'app-status-deployment-during-modal',
  templateUrl: './status-deployment-during-modal.component.html'
})

export class StatusDeploymentDuringModalComponent implements OnInit, OnDestroy {
  @Input() deploymentId: any;
  @Input() status: any;
  @Input() description: any;
  @Input() mode: 'edit' | 'add';
  @Input() deploymentList: any[];
  duringDeploymentModal: FormGroup;
  @Input() data;

  constructor(private fb: FormBuilder,
              public propertiesService: PropertiesService,
              private customEventService: CustomEventService) { }

  ngOnInit(): void {
    this.createForm();
  }


  createForm(): void {
    const { status = this.status, description = this.description, fixDeploymentId = '' } = this.data;

    this.duringDeploymentModal = this.fb.group({
      description: [description, [Validators.required]],
      status: [status, [Validators.required]],
      fixDeploymentId: [fixDeploymentId]
    });
  }


  submitForm(): void {
    validateFormGroup(this.duringDeploymentModal);

    if (this.duringDeploymentModal.invalid) {
      return;
    }

    const formData = {
      ...this.duringDeploymentModal.value,
      deploymentId: this.deploymentId};

    this.customEventService.announceEvent(ActionTypesEnum.CHANGE_STATUS_DEPLOYMENT_DURING, formData);
  }

  cancelForm(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

  ngOnDestroy(): void {}

}
